<div *ngIf="!fromTraining" style="height: 100vh; width: 100%"
  class="d-flex flex-column align-items-center justify-content-between">
  <app-admin-header style="width: 100%" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"
    [queryParams]="queryParams"></app-admin-header>

  <!-- new ui section  -->

  <!-- Back button for standard question bank -->
  <div class="w-100">
    <div class="d-flex justify-content-start w-100 btn-section" *ngIf="currentQBankId === standardQBID">
      <button class="v4-btn-every" (click)="navigateToAssessment()">
        <i class="pi pi-arrow-right me-2"></i>
        {{ 'Back' | translator }}
      </button>
    </div>

    <p-toast></p-toast>
    <div class="container-fluid mb-5 ">
      <div class="row">
        <div *ngIf="currentQBankId !== standardQBID" class="col-lg-2 col-md-2 col-sm-12 col-12 m-0">
          <div class="at-sidebar-filters">

            <div class="at-filter-section">
              <!-- Organizational Unit Filter -->
              <div class="at-filter-group">
                <div class="at-filter-header" (click)="toggleFilter('ou')">
                  <span class="at-filter-title">{{ 'Organization' | translator }}</span>
                  <i class="pi at-filter-icon"
                    [ngClass]="isFilterExpanded('ou') ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                </div>
                <div class="at-filter-options p-2" *ngIf="isFilterExpanded('ou')">
                  <!-- First Dropdown: Ministry/Entity Selection -->
                  <div class="mb-2">
                    <label class="filter-label mb-1" style="font-size: 12px; color: var(--color-dark-blue)">{{
                      'Ministry/Entity' |
                      translator }}</label>
                    <p-dropdown class="w-100 ppp-dropdown" [(ngModel)]="selectedMinistry"
                      [options]="availableMinistries" optionLabel="label" appendTo="body"
                      (onChange)="onMinistryChange()" [placeholder]="'Select Ministry/Entity' | translator"
                      [filter]="true" [filterBy]="'label'">
                      <ng-template let-node pTemplate="item">
                        <div class="d-flex align-items-center">
                          <img *ngIf="checkisImg(node.data); else elseBlock1" src="{{ staticURL }}{{ node.data }}"
                            class="img-fluid p-1 tree-img-bg" style="max-height: 20px; max-width: 20px" />
                          <ng-template #elseBlock1>
                            <i class="{{ node.data }} p-1" style="font-size: 0.8rem"></i>
                          </ng-template>
                          <span class="text-nowrap ms-2" style="font-size: 0.8rem;">{{ node.label }}</span>
                        </div>
                      </ng-template>
                      <ng-template let-node pTemplate="selectedItem">
                        <div class="d-flex align-items-center" *ngIf="node">
                          <img *ngIf="checkisImg(node.data); else elseBlock2" src="{{ staticURL }}{{ node.data }}"
                            class="img-fluid p-1 tree-img-bg" style="max-height: 18px; max-width: 18px" />
                          <ng-template #elseBlock2>
                            <i class="{{ node.data }} p-1" style="font-size: 0.7rem"></i>
                          </ng-template>
                          <span class="text-nowrap ms-2" style="font-size: 0.75rem;">{{ node.label }}</span>
                        </div>
                      </ng-template>
                    </p-dropdown>
                  </div>

                  <!-- Second Dropdown: Department/Division/Branch Tree Selection -->
                  <div *ngIf="selectedMinistry && availableDepartments.length > 0">
                    <label class="filter-label mb-1" style="font-size: 0.75rem; color: #666;">{{ 'Department/Division' |
                      translator }}</label>
                    <p-treeSelect class="w-100 ppp-dropdown" [(ngModel)]="selectedDepartment"
                      [options]="availableDepartments" appendTo="body" (onNodeSelect)="onDepartmentChange()"
                      (onClear)="onDepartmentChange()" [placeholder]="'Select Department/Division' | translator"
                      [filter]="true" filterBy="label" selectionMode="single">
                      <ng-template let-node pTemplate="default">
                        <div class="d-flex align-items-center">
                          <img *ngIf="checkisImg(node.data); else elseBlock3" src="{{ staticURL }}{{ node.data }}"
                            class="img-fluid p-1 tree-img-bg" style="max-height: 20px; max-width: 20px" />
                          <ng-template #elseBlock3>
                            <i class="{{ node.data }} p-1" style="font-size: 0.8rem"></i>
                          </ng-template>
                          <span class="ms-2" style="font-size: 0.8rem;">{{ node.label }}</span>
                        </div>
                      </ng-template>
                    </p-treeSelect>
                  </div>

                  <!-- Message when no departments available -->
                  <div *ngIf="selectedMinistry && availableDepartments.length === 0" class="text-muted text-center p-2"
                    style="font-size: 0.75rem;">
                    {{ 'No departments available' | translator }}
                  </div>
                </div>
              </div>

              <!-- Question Bank Filter (Paths) -->
              <div class="at-filter-group">
                <div class="at-filter-header" (click)="toggleFilter('qb')">
                  <span class="at-filter-title">{{ 'Question Bank Heading' | translator }}</span>
                  <i class="pi at-filter-icon"
                    [ngClass]="isFilterExpanded('qb') ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                </div>
                <div class="at-filter-options v4-scroll" *ngIf="isFilterExpanded('qb')">
                  <!-- Loader while fetching paths -->
                  <div *ngIf="loadingPaths" class="d-flex justify-content-center align-items-center p-3">
                    <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem;"></i>
                    <span class="ms-2">{{ 'Loading...' | translator }}</span>
                  </div>

                  <!-- Paths list -->
                  <app-question-bank *ngIf="!loadingPaths" [tags]="allTags" [currentQBank]="currentQBank"
                    [questionBanks]="filteredQuestionBanks" (assessment)="changeCurrentQBank($event)"
                    (updateDataEvent)="ngOnInit()"></app-question-bank>

                  <app-no-data
                    *ngIf="!loadingPaths && !skelition && filteredQuestionBanks && filteredQuestionBanks.length === 0"></app-no-data>
                </div>
              </div>

            </div>


            <div class="at-filter-actions mt-3">
              <button class="v4-btn-every w-100 mb-2" (click)="openAddQBModal()">
                <i class="pi pi-plus-circle mx-2"></i>{{ "Add Question Bank" | translator }}
              </button>
              <button class="v4-btn-every w-100 mb-2" (click)="clearFilters()" *ngIf="selectedOU || currentQBankId">
                <i class="pi pi-filter-slash mx-2"></i>{{ "Clear" | translator }}
              </button>
              <button class="refresh-btn w-100" (click)="refreshPage()">
                <i class="pi pi-refresh mx-2"></i>{{ "Refresh" | translator }}
              </button>
            </div>
          </div>
        </div>
        <div
          class="{{currentQBankId !== standardQBID ? 'col-lg-10 col-md-10 col-sm-12 col-12' : 'col-lg-12 col-md-12 col-sm-12 col-12'}}">
          <div class="option-box-2 mob-top-2">
            <!-- skelition   -->
            <app-skelitions [hidden]="!skelition" [value]="2" class="mb-2"></app-skelitions>

            <div *ngIf="!skelition">
              <p-tabView class="v4-dsbrd-btns" [activeIndex]="activeTabIndex" (onChange)="onTabChange($event)">
              <p-tabPanel class="v4-dsbrd-btns" header="{{ 'Assessments' | translator }}"
                *ngIf="standardQBID != currentQBankId">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 p-0">
                    <div class="arbx-main-dashboard">

                      <div class="arbx-header-flex">
                        <!-- STATS -->
                        <div class="arbx-stats-flex">
                          <!-- CARD -->
                          <div class="arbx-stat-card">

                            <div class="arbx-stat-icon arbx-purple">
                              <i class="fa-solid fa-chart-column"></i>
                            </div>

                            <div class="arbx-stat-content">

                              <div class="arbx-stat-title">
                                إجمالي الإجابات
                              </div>

                              <div class="arbx-stat-number">
                                {{ totalAttemptsCount | number }}
                              </div>

                              <div class="arbx-stat-subtitle">
                                إجابة
                              </div>

                            </div>

                          </div>

                          <!-- CARD -->
                          <div class="arbx-stat-card">

                            <div class="arbx-stat-icon arbx-orange">
                              <i class="fa-regular fa-pen-to-square"></i>
                            </div>

                            <div class="arbx-stat-content">

                              <div class="arbx-stat-title">
                                المسودة
                              </div>

                              <div class="arbx-stat-number">
                                {{ draftAssessmentsCount | number }}
                              </div>

                              <div class="arbx-stat-subtitle">
                                اختبار
                              </div>

                            </div>

                          </div>

                          <!-- CARD -->
                          <div class="arbx-stat-card">

                            <div class="arbx-stat-icon arbx-green">
                              <i class="fa-solid fa-circle-check"></i>
                            </div>

                            <div class="arbx-stat-content">

                              <div class="arbx-stat-title">
                                النشطة
                              </div>

                              <div class="arbx-stat-number">
                                {{ activeAssessmentsCount | number }}
                              </div>

                              <div class="arbx-stat-subtitle">
                                اختبار
                              </div>

                            </div>

                          </div>

                          <!-- CARD -->
                          <div class="arbx-stat-card">

                            <div class="arbx-stat-icon arbx-purple">
                              <i class="fa-regular fa-clipboard"></i>
                            </div>

                            <div class="arbx-stat-content">

                              <div class="arbx-stat-title">
                               {{ "Total Assessments" | translator }}
                              </div>

                              <div class="arbx-stat-number">
                                {{ totalAssessmentsCount | number }}
                              </div>

                              <div class="arbx-stat-subtitle">
                                اختبار
                              </div>

                            </div>

                          </div>

                        </div>

                      </div>

                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 p-0">
                    <div class="d-flex align-items-center gap-2 mb-3">
                      <button *ngIf="!!currentQBank" (click)="createModal()" class="v4-btn-border">
                        <div class="d-flex align-items-center gap-2">
                          <i class="pi pi-plus-circle mx-2"></i><span class="text-nowrap">{{ "New Assessment" |
                            translator }}</span>
                        </div>
                      </button>
                      <!-- <button
                      *ngIf="hasPermission('SURVEY_TAGS', 'c') || hasPermission('SURVEY_TAGS', 'u') || hasPermission('SURVEY_TAGS', 'd')"
                      routerLink="/assessment/tags-management" class="mb-3 v4-btn-border">
                      <i class="pi pi-plus-circle mx-2"></i>{{ "Tags Management" | translator }}
                    </button> -->
                      <div class="w-100">
                        <div class="d-flex align-items-center gap-2 w-100">
                          <span class="p-input-icon-right w-100">
                            <i class="pi" [ngClass]="searching ? 'pi-spin pi-spinner' : 'pi-search'"></i>
                            <input type="text" pInputText [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
                              placeholder="{{ 'Search assessments...' | translator }}" class="input-ui" />
                          </span>
                          <span *ngIf="searchResults !== null" class="text-muted text-nowrap">
                            <ng-container *ngIf="searchTotal > searchResults.length">
                              {{ searchResults.length }} {{ 'of' | translator }}
                            </ng-container>
                            {{ searchTotal }} {{ 'results' | translator }}
                          </span>
                          <span *ngIf="useLocalSearch && searchText && searchText.trim() !== ''" class="text-muted text-nowrap">
                            {{ filteredAssessments.length }} {{ 'of' | translator }} {{ assessments.length }} {{
                            'results' | translator }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="arbx-filter-main">

                      <!-- RIGHT SIDE -->
                      <div class="arbx-filter-right-side">

                        <div class="arbx-filter-heading">
                          الفترة المحددة:
                        </div>

                        <!-- CHIP 1: Static Selected Question Bank Chip (When selected) -->
                        <div *ngIf="currentQBank" class="arbx-filter-pill">
                          <i class="fa-solid fa-xmark arbx-filter-close" style="cursor: pointer;" (click)="clearQBankFilter($event)"></i>
                          <span class="arbx-filter-text">
                            نوع الاختبار : {{ currentQBank.name }}
                          </span>
                        </div>
 
                        <!-- CHIP 2: Status Dropdown (Only when not selected) -->
                        <p-dropdown 
                          *ngIf="!statusFilter"
                          class="arbx-dropdown-pill" 
                          [options]="statusDropdownOptions" 
                          [(ngModel)]="statusFilter" 
                          (onChange)="onStatusDropdownChange($event)"
                          placeholder="الحالة : جميع"
                          appendTo="body"
                          scrollHeight="200px">
                          <ng-template let-status pTemplate="item">
                            <span>{{ status.label }}</span>
                          </ng-template>
                        </p-dropdown>

                        <!-- CHIP 2: Static Selected Status Chip (When selected) -->
                        <div *ngIf="statusFilter" class="arbx-filter-pill">
                          <i class="fa-solid fa-xmark arbx-filter-close" style="cursor: pointer;" (click)="clearStatusFilter($event)"></i>
                          <span class="arbx-filter-text">
                            الحالة : {{ getStatusArabic(statusFilter) }}
                          </span>
                        </div>

                        <!-- CLEAR -->
                        <div class="arbx-clear-filter" style="cursor: pointer;" (click)="clearAllFilters()">

                          <i class="fa-solid fa-rotate-left"></i>

                          لمسح الكل

                        </div>

                      </div>

                    </div>
                    <!-- Search Field -->
                    <!-- <div class="mb-3 w-100" *ngIf="assessments.length > 0">
                    <div class="d-flex align-items-center gap-2 w-100">
                      <span class="p-input-icon-right w-100">
                        <i class="pi pi-search"></i>
                        <input 
                          type="text" 
                          pInputText 
                          [(ngModel)]="searchText" 
                          (ngModelChange)="onSearchChange()"
                          placeholder="{{ 'Search assessments...' | translator }}"
                          class="input-ui" />
                      </span>
                      <span *ngIf="searchText && searchText.trim() !== ''" class="text-muted">
                        {{ filteredAssessments.length }} {{ 'of' | translator }} {{ assessments.length }} {{ 'results' | translator }}
                      </span>
                    </div>
                  </div> -->
                    <div *ngIf="searchResults === null && assessments.length <= 0" class="mt-2">
                      <app-no-data></app-no-data>
                    </div>
                    <div
                      *ngIf="!searching && filteredAssessments.length === 0 && searchText && searchText.trim() !== '' && (searchResults !== null || assessments.length > 0)"
                      class="mt-2 text-center p-4">
                      <i class="pi pi-info-circle text-muted" style="font-size: 2rem;"></i>
                      <p class="text-muted mt-2">{{ 'No assessments found matching your search' | translator }}</p>
                    </div>
                    <div class="over-flow-y-left w-100">
                      <div class="table-wrapper w-100">
                        <table *ngIf="filteredAssessments.length > 0" class="w-100">
                          <thead>
                            <tr>
                              <th>
                                <div class="d-flex align-items-center">
                                  <p-checkbox class="custom-survey-checkbox" [(ngModel)]="checkboxValue"
                                    (ngModelChange)="markAll()" [binary]="true" inputId="binary"></p-checkbox>
                                  <!-- <input
                                type="checkbox"
                                [(ngModel)]="checkboxValue"
                                (ngModelChange)="markAll()"
                              /> -->
                                </div>
                              </th>
                              <th class="clickable" (click)="sortAssessments('name')"
                                class="table-row-mob-width clickable">
                                <span>{{ "Assessment name" | translator }}</span>
                                <i class="pi" [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'name' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'name' &&
                                    sortDirection === 'desc'
                                }"></i>
                              </th>
                              <th class="table-row-mob-width-type clickable"
                                (click)="sortAssessments('type')">
                                <span>{{ "Type" | translator }}</span>
                                <i class="pi" [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'type' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'type' &&
                                    sortDirection === 'desc'
                                }"></i>
                              </th>
                              <th class="table-row-mob-width-name">
                                {{ "Created By" | translator }}
                              </th>
                              <th class="clickable" (click)="sortAssessments('createdAt')">
                                <span>{{ "Created" | translator }}</span>
                                <i class="pi" [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'createdAt' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'createdAt' &&
                                    sortDirection === 'desc'
                                }"></i>
                              </th>
                              <th class="clickable" (click)="sortAssessments('updatedAt')">
                                <span>{{ "Modified" | translator }}</span>
                                <i class="pi" [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'updatedAt' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'updatedAt' &&
                                    sortDirection === 'desc'
                                }"></i>
                              </th>
                              <th class="clickable" (click)="sortAssessments('startDate')">
                                <span>{{ "Start Date" | translator }}</span>
                                <i class="pi" [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'startDate' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'startDate' &&
                                    sortDirection === 'desc'
                                }"></i>
                              </th>
                              <th class="clickable" (click)="sortAssessments('endDate')">
                                <span>{{ "End Date" | translator }}</span>
                                <i class="pi" [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'endDate' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'endDate' &&
                                    sortDirection === 'desc'
                                }"></i>
                              </th>
                              <th class="clickable" (click)="sortAssessments('status')">
                                <span>{{ "the condition" | translator }}</span>
                                <i class="pi" [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'status' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'status' &&
                                    sortDirection === 'desc'
                                }"></i>
                              </th>
                              <th class="clickable" (click)="sortAssessments('attempts')">
                                <span>{{ "Responses" | translator }}</span>
                                <i class="pi" [ngClass]="{
                                  'pi-sort-up':
                                    sortField === 'attempts' &&
                                    sortDirection === 'asc',
                                  'pi-sort-down':
                                    sortField === 'attempts' &&
                                    sortDirection === 'desc'
                                }"></i>
                              </th>
                              <th>{{ "Actions" | translator }}</th>
                            </tr>
                            <!-- <br /> -->
                          </thead>
                          <tbody>
                            <tr *ngFor="
                              let assessment of filteredAssessments;
                              let i = index
                            ">
                              <td>
                                <div class="d-flex align-items-center">
                                  <p-checkbox class="custom-survey-checkbox" [(ngModel)]="assessment.selected"
                                    (ngModelChange)="
                                  selectAssessment(assessment, $event)
                                " [binary]="true" inputId="binary"></p-checkbox>
                                  <!-- <input
                                type="checkbox"
                                [(ngModel)]="assessment.selected"
                                (ngModelChange)="
                                  selectAssessment(assessment, $event)
                                "
                              /> -->
                                </div>
                              </td>
                              <td class="table-row-mob-width show-count d-flex flex-row gap-2 align-items-center">
                                <!-- <p-button tooltipPosition="top" pTooltip="{{ 'Copy' | translator }}" class="v4-ui"
                                (onClick)="setCloneQestions(assessment,assessment.questionBank._id)"
                                styleClass="p-button-rounded p-button-text" icon="pi pi-copy"></p-button>
                              <p-button tooltipPosition="top" pTooltip="{{'results'|translator}}" class="v4-ui" (onClick)="openResultsPage(assessment)"
                                styleClass="p-button-rounded p-button-text" icon="pi pi-chart-bar"></p-button> -->
                                <div (click)="openAddQuestionsPage(assessment)" class="align-self-center"
                                  style="font-size: 12px" role="button">
                                  {{ assessment.name }}</div>
                                <div class="question-count" style="color: var(--color-dark-blue-text)">
                                  Questions{{ assessment.questions.length }}</div>
                              </td>
                              <td>
                                <div class="table-data">{{ assessment.questionBank?.name }}</div>
                              </td>
                              <td>
                                <div class="table-data">{{ getName(assessment?.createdBy?.name) }}</div>
                              </td>
                              <td>
                                <div class="table-data">{{ assessment.createdAt | date }}</div>
                              </td>
                              <td>
                                <div class="table-data">{{ assessment.updatedAt | date }}</div>
                              </td>
                              <td>
                                <div class="table-data">{{ getTransformedDate(assessment.startDate) }}</div>
                              </td>
                              <td>
                                <div class="table-data">{{ getTransformedDate(assessment.endDate) }}</div>
                              </td>
                              <td>
                                <select class="tab-drop" name="{{ assessment.status }}" id="{{ assessment.status }}"
                                  [ngClass]="{
                                    'status-draft': assessment.status === 'Draft',
                                    'status-pending': assessment.status === 'Pending',
                                    'status-active': assessment.status === 'Active',
                                    'status-closed': assessment.status === 'Closed'
                                  }"
                                  [(ngModel)]="assessment.status" (ngModelChange)="
                                  updateAssessmentData(assessment)
                                ">
                                  <option *ngFor="let option of statusOptions" [value]="option">
                                    {{ getStatusArabic(option) }}
                                  </option>
                                </select>
                              </td>
                              <td [style]="{ 'text-align': 'center' }">{{ assessment.attempts }}</td>
                              <td>
                                <div class="d-flex align-items-center gap-2">
                                  <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
                                  <p-button tooltipPosition="top" pTooltip="{{ 'Copy' | translator }}" class="v4-ui"
                                    (onClick)="setCloneQestions(assessment,assessment.questionBank._id)"
                                    styleClass="p-button-rounded p-button-text" icon="pi pi-copy tab-pi"></p-button>
                                  <p-button tooltipPosition="top" pTooltip="{{'results'|translator}}" class="v4-ui"
                                    (onClick)="openResultsPage(assessment)" styleClass="p-button-rounded p-button-text"
                                    icon="pi pi-chart-bar tab-pi"></p-button>
                                  <p-button class="v4-ui" (onClick)="
                                  openAssessmentMenu(menu, $event, assessment)
                                " styleClass="p-button-rounded p-button-text"
                                    icon="pi pi-ellipsis-v tab-pi"></p-button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- CUSTOM PAGINATION START -->

                      <!-- <div class="rtp-wrapper" dir="rtl" *ngIf="filteredAssessments.length > 10">
                        <div class="rtp-control-panel">
                          <button class="rtp-btn-nav" (click)="prevPage()" [disabled]="page === 1">السابق</button>
                          <div class="rtp-number-strip">
                            <ng-container *ngFor="let p of pagesArray">
                              <button class="rtp-btn-digit" [class.rtp-is-active]="page === p" (click)="setPage(p)">
                                {{ p }}
                              </button>
                            </ng-container>
                          </div>
                          <button class="rtp-btn-nav" (click)="nextPage()" [disabled]="page === totalPages">التالي</button>
                        </div>

                        <div class="rtp-meta-info">
                          <div class="rtp-status-text">
                            عرض {{ pageStart }} إلى {{ pageEnd }} من {{ filteredAssessments.length }} اختبار
                          </div>
                          <div class="rtp-select-group">
                            <span>عرض</span>
                            <select class="rtp-dropdown" [ngModel]="rows" (ngModelChange)="onRowsChange($event)">
                              <option [value]="10">10</option>
                              <option [value]="25">25</option>
                              <option [value]="50">50</option>
                            </select>
                          </div>
                        </div>
                      </div> -->

                      <!-- CUSTOM PAGINATION END -->
                    </div>
                    <!-- Action buttons section outside scroller -->
                    <div class="table-actions-wrapper mt-3" *ngIf="selectedAssessments.length > 0">
                      <div class="d-flex align-items-center gap-2">
                        <p-button *ngIf="false" (onClick)="
        assessmentActionCall({
          action: 'Group',
          bulk: true
        })
      " styleClass="v4-btn-every m-l-2" icon="pi pi-folder" label="{{ 'Create Group' | translator }}"></p-button>
                        <p-button (onClick)="
        assessmentActionCall({
          action: 'Results',
          bulk: true
        })
      " styleClass="v4-btn-every m-l-2" icon="pi pi-chart-bar" label="{{ 'Results' | translator }}"></p-button>
                        <p-button (onClick)="
        assessmentActionCall({
          action: 'Delete',
          bulk: true
        })
      " styleClass="v4-btn-every" icon="pi pi-trash" label="{{ 'Delete' | translator }}"></p-button>
                        <span>{{ "selected" | translator }} {{ selectedAssessments.length }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </p-tabPanel>
              <p-tabPanel header="{{ 'Topics' | translator }}" *ngIf="!!currentQBank">
                <app-question-bank-list [currentQBank]="currentQBank" [currentQBankId]="currentQBankId"
                  [activeTabIndex]="activeTabIndex" [questionBankService]="questionBankService"
                  [questionBankTopics]="questionBankTopics" [ministries]="ministries" [topics]="topics"
                  (updateDataEvent)="ngOnInit()"></app-question-bank-list>
              </p-tabPanel>
            </p-tabView>
          </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->

    <!-- Confirm Modal -->
    <p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

    <!-- Update Data Modal -->
    <p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="updateModal"
      (onHide)="onDialogClose()" [style]="{ margin: '0rem 1rem' }">
      <ng-template pTemplate="header">
        <span class="text-xl font-bold">{{ "Update" | translator }}</span>
      </ng-template>
      <app-dynamic-form *ngIf="updateModal" [questions]="updateQuestions"
        (sendData)="updateAssessmentData($event)"></app-dynamic-form>
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    </p-dialog>

    <!-- Create new Modal -->
    <p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openCreateModal"
      (onHide)="onDialogClose()" [style]="{ width: '95vw' , maxWidth: '1000px' }">
      <ng-template pTemplate="header">
        <span class="text-xl font-bold">{{
          "Create a new assessment" | translator
          }}</span>
      </ng-template>
      <app-dynamic-form [questions]="questions" (sendData)="receiveAssessmentData($event)"></app-dynamic-form>
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    </p-dialog>

    <app-footer style="width: 100%"></app-footer>
  </div>

  <section *ngIf="fromTraining">
    <app-dynamic-form [questions]="
      updateModal && updateAssesData?._id ? updateQuestions : questions
    " (sendData)="
      updateModal && updateAssesData?._id
        ? updateAssessmentData($event)
        : receiveAssessmentData($event)
    "></app-dynamic-form>

    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  </section>